// Model.js
// -----------------------
// @module Case
define("Ames.HomeStore.HomeStore.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/HomeStore/SuiteScript2/HomeStore.Service.ss"
            ),
            true
        )
});
});
